import { render, staticRenderFns } from "./ProfileTableMenu.vue?vue&type=template&id=24506ef6&scoped=true&"
import script from "./ProfileTableMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24506ef6",
  null
  
)

export default component.exports